import api from '../../api';

export default class RuleService implements RuleService {
    async fetchAll(): Promise<Rules> {
        // TODO: we might want to separate Rules into internal and external types
        const response = await api.bff.fetchRules();
        return response.data;
    }
}
